// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cs-2";
export var aiChatCartContainerExit = "_cs-4";
export var aiChatContainerLarge = "_cs-0";
export var aiChatContainerSmall = "_cs-1";
export var aiChatIcon = "_cs-6";
export var slideInFromRight = "_cs-3";
export var slideOutToRight = "_cs-5";